import { h } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import style from './style.css';

const ColorInput = ({currentColor, changeColors}) => {
  const [color, setColor] = useState(currentColor);
  const [valid, setValid] = useState(true);

  useEffect(() => {
    setColor(currentColor);
  }, [currentColor]); // if the props change, please also update state

  const update = (event) => {
    const hex = event.target.value;
    setColor(event.target.value);

    if(/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(hex)) {      
      changeColors(event.target.value);  
      setValid(true);
    } else {
      setValid(false);
    }
  }
  
  return (
    <div className={valid ? style.colorRow : style.colorRowInvalid} >
      <div className={style.swatch} style={{backgroundColor: color}} />
      <input type="text" className={style.colorField} value={color} onInput={update}></input>
    </div>
  )
}

export default ColorInput;